module.exports = __webpack_public_path__ + "img/美妆美体.902e2650.png";